import { registerLocaleData } from '@angular/common';
import localeAf from '@angular/common/locales/af';
import localeAfExtra from '@angular/common/locales/extra/af';
import localeCs from '@angular/common/locales/cs';
import localeCsExtra from '@angular/common/locales/extra/cs';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import localeEs from '@angular/common/locales/es';
import localeEsExtra from '@angular/common/locales/extra/es';
import localeEs419 from '@angular/common/locales/es-419';
import localeEs419Extra from '@angular/common/locales/extra/es-419';
import localeFr from '@angular/common/locales/fr';
import localeFrExtra from '@angular/common/locales/extra/fr';
import localeFrCa from '@angular/common/locales/fr-CA';
import localeFrCaExtra from '@angular/common/locales/extra/fr-CA';
import localeHe from '@angular/common/locales/he';
import localeHeExtra from '@angular/common/locales/extra/he';
import localeIt from '@angular/common/locales/it';
import localeItExtra from '@angular/common/locales/extra/it';
import localeJa from '@angular/common/locales/ja';
import localeJaExtra from '@angular/common/locales/extra/ja';
import localeNl from '@angular/common/locales/nl';
import localeNlExtra from '@angular/common/locales/extra/nl';
import localePt from '@angular/common/locales/pt';
import localePtExtra from '@angular/common/locales/extra/pt';
import localeRu from '@angular/common/locales/ru';
import localeRuExtra from '@angular/common/locales/extra/ru';
import localeSv from '@angular/common/locales/sv';
import localeSvExtra from '@angular/common/locales/extra/sv';
import { Language } from '@vendasta/galaxy/i18n';

type LocaleData = unknown[];

const LOCALE_DATA: Record<Language, [LocaleData, LocaleData] | null> = {
  [Language.ENGLISH]: null,
  [Language.AFRIKAANS]: [localeAf, localeAfExtra],
  [Language.CZECH]: [localeCs, localeCsExtra],
  [Language.DUTCH]: [localeNl, localeNlExtra],
  [Language.FRENCH]: [localeFr, localeFrExtra],
  [Language.FRENCH_CANADA]: [localeFrCa, localeFrCaExtra],
  [Language.FRENCH_FRANCE]: [localeFr, localeFrExtra],
  [Language.GERMAN]: [localeDe, localeDeExtra],
  [Language.HEBREW]: [localeHe, localeHeExtra],
  [Language.ITALIAN]: [localeIt, localeItExtra],
  [Language.JAPANESE]: [localeJa, localeJaExtra],
  [Language.PORTUGUESE]: [localePt, localePtExtra],
  [Language.RUSSIAN]: [localeRu, localeRuExtra],
  [Language.SPANISH_LATIN_AMERICA]: [localeEs419, localeEs419Extra],
  [Language.SPANISH]: [localeEs, localeEsExtra],
  [Language.SWEDISH]: [localeSv, localeSvExtra],
};

export function registerBookmeLocaleData(): void {
  for (const [code, data] of Object.entries(LOCALE_DATA)) {
    if (data) {
      registerLocaleData(data[0], code, data[1]);
    }
  }
}
